import { useState } from "react";

export const Why = () => {
  const [active, setActive] = useState(1);
  const activeText = [
    "通过全球50多个国家/地区的POP点，组件覆盖全球的骨干专线网络",
    "线路源自运营商国际专线，安全合规，相关业务资质合法合规，保障长期使用高效稳定无风险 ",
    "即插即用，极简配置，可快速接入全球加速网络，支持配合业务灵活调整，迁移无忧",
    "网络资源覆盖全球180多个国家与地区支持独享住宅IP，定位精准，极高的匿名隐私保护",
    "网络资源覆盖全球180多个国家与地区支持独享住宅IP，定位精准，极高的匿名隐私保护",
    "拥有完整的线上线下售前售后体系，随时在线为您提供专业的技术与服务支持",
  ];
  return (
    <div className="flex justify-center ">
      <div className="px-[240px] pb-[80px] pt-[100px] w-[1920px]">
        <div className="flex items-center gap-[160px]">
          <div className="flex-1">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[45px] text-[#333333]">
              为什么要选择光年无界企业出海？
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#777777] mt-[30px]">
              我们自研的光年KWAN加速引擎提供的SD-WAN组网方案，可以为出海企业快速搭建专用的的国际网络，通过自动化管理系统，为不同行业和规模的企业提供多样产品，可以快速满足各个业务场景的接入需求。
            </div>
            <div className="flex gap-[20px] mt-[60px]">
              <Item
                svg={svg1}
                title1="全球骨干"
                title2="网络覆盖"
                onHover={() => {
                  setActive(1);
                }}
              />
              <Item
                svg={svg2}
                title1="线路合规"
                title2="稳定资质"
                onHover={() => {
                  setActive(2);
                }}
              />
              <Item
                svg={svg3}
                title1="方案灵活"
                title2="提供定制服务"
                onHover={() => {
                  setActive(3);
                }}
              />
            </div>
            <div className="flex gap-[20px] mt-[20px]">
              <Item
                svg={svg4}
                title1="原生IP"
                title2="资源丰富"
                onHover={() => {
                  setActive(4);
                }}
              />
              <Item
                svg={svg5}
                title1="即插即用"
                title2="快速部署"
                onHover={() => {
                  setActive(5);
                }}
              />
              <Item
                svg={svg6}
                title1="强大技术支持"
                title2="售前售后无忧"
                onHover={() => {
                  setActive(6);
                }}
              />
            </div>
          </div>
          <div className="flex items-center gap-[20px] flex-col">
            <img
              className="w-[460px] h-[460px] bg-white "
              src={`/imgs/sdwan/why/${active}.png`}
            />
            <div
              className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30]
           font-normal text-[18px] text-[rgba(0,51,102,0.6)]  text-center"
            >
              {activeText[active - 1]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Item = ({
  svg,
  title1,
  title2,
  onHover,
}: {
  svg: React.ReactNode;
  title1: string;
  title2: string;
  onHover: () => void;
}) => {
  return (
    <div
      onMouseEnter={onHover}
      className="group p-[10px] py-[30px] pr-[0px] w-[260px] h-[112px] bg-gradient-to-b from-[rgba(243,247,255,0.95)] to-[#D2EAFF] shadow-[0px_4px_30px_0px_rgba(0,0,0,0.08)] rounded-[12px] gap-[20px] hover:w-[260px] hover:h-[112px] hover:bg-gradient-to-br hover:from-[#6EB4FF] hover:via-[#8AABFF] hover:to-[#AB9FFF] hover:shadow-[0px_4px_30px_0px_rgba(0,0,0,0.08)] hover:rounded-[12px] flex items-center "
    >
      <div className="w-[70px] h-[70px] [&_svg_path]:transition-colors group-hover:[&_svg_path]:!fill-white">
        {svg}
      </div>
      <div className="w-[2px] h-full bg-[#39A2FF] group-hover:bg-white" />
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[20px] text-[#333333] group-hover:text-white">
        <div>{title1}</div>
        <div>{title2}</div>
      </div>
    </div>
  );
};

const svg1 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.5 6C50.2408 6 63 18.7592 63 34.5C63 50.2408 50.2408 63 34.5 63C18.7592 63 6 50.2408 6 34.5C6 18.7592 18.7592 6 34.5 6ZM46.3224 13.4758L46.3385 13.4422C46.1295 13.9098 45.9205 14.3629 45.7071 14.8014L45.2803 15.6593C42.917 20.2632 40.2818 23.005 36.7011 23.005C35.7745 23.005 35.1723 23.0474 34.7587 23.138L34.4971 23.1994C34.4912 23.1994 34.4883 23.1979 34.4883 23.195L34.4795 23.2125C34.4478 23.3381 34.4403 23.4686 34.4576 23.5969L34.4868 23.8571L34.5438 24.1815L34.6286 24.5718L34.6842 24.791L34.8215 25.2792C34.8464 25.3668 34.8742 25.456 34.9034 25.5495L35.0992 26.1415C35.1723 26.3505 35.2498 26.5712 35.3375 26.8035C36.7113 30.472 35.8168 34.0732 33.3439 36.0522C30.6503 38.2079 26.9979 37.5575 25.6518 34.139L25.2382 33.1013L24.8845 32.2419L24.6755 31.7582L24.4402 31.2466L24.2268 30.8315L24.1465 30.6898L23.9915 30.4428C23.7138 30.0379 23.4654 29.8698 23.1585 29.8041L22.9407 29.7734L22.6981 29.7661L21.5245 29.7807L20.7835 29.7763C19.1465 29.7456 18.1162 29.522 17.1355 28.7737C15.4839 27.5124 15.3012 25.5115 16.2454 23.0825L16.3769 22.7638C17.0682 21.1284 16.982 19.9782 16.0539 18.9682C12.3848 23.3109 10.3758 28.8148 10.3846 34.5C10.3846 47.819 21.1825 58.6154 34.5 58.6154C36.6528 58.6154 38.7385 58.3333 40.7232 57.8042C41.0448 55.8955 40.3096 54.3769 38.4125 52.9695L38.1378 52.7722C32.3735 48.7602 32.1162 42.3996 36.59 39.6768C40.0626 37.5619 43.8246 37.5195 46.622 40.2658L46.8807 40.5318C47.4361 41.1237 47.7722 41.359 48.0309 41.4335L48.1654 41.4628L48.3335 41.4715L48.4869 41.4657L48.8275 41.4292L49.5977 41.3254C50.1253 41.2508 50.5258 41.2041 50.9745 41.1734C53.5833 40.9907 55.286 42.0065 56.5137 44.3595C57.9039 41.2587 58.6202 37.8982 58.6154 34.5C58.6154 25.4765 53.6608 17.6119 46.3224 13.4758ZM38.8685 43.4227C37.3018 44.3771 37.3485 46.7345 40.3535 48.9663L40.6428 49.1738C43.3715 51.0738 44.8915 53.4503 45.1444 56.1454C48.4621 54.5094 51.3606 52.1344 53.6169 49.2031L53.5438 48.902L53.3831 48.3028L53.3056 48.0324L53.1536 47.5398L53.0776 47.3177L52.9285 46.9216C52.4535 45.7641 51.9785 45.4981 51.2799 45.5478L50.8853 45.5814L50.4556 45.6325L49.3668 45.7816L48.8406 45.8401L48.4168 45.8664C48.2216 45.8721 48.0262 45.8643 47.8322 45.843L47.4419 45.7875L47.3557 45.7728C46.0374 45.5405 44.8945 44.8243 43.6799 43.5279C42.4668 42.2315 40.8416 42.2213 38.87 43.4212L38.8685 43.4227ZM34.5015 10.3846C28.6787 10.3846 23.3368 12.4483 19.1699 15.8858C21.2848 18.103 21.7715 20.9632 20.5613 24.1085L20.4152 24.4724C20.3048 24.7275 20.2115 24.9897 20.136 25.2572L20.1126 25.3449L20.4707 25.3742L20.7732 25.3888L20.9442 25.3917H21.8197L22.6995 25.3815C25.3098 25.3815 26.653 26.1605 28.0239 28.6875L28.3192 29.256L28.6173 29.8801L28.9228 30.5612L29.237 31.3036L29.7339 32.5328C29.9239 33.018 30.0832 33.0472 30.605 32.6292C31.5623 31.8634 31.9569 30.2762 31.2335 28.3425C29.8757 24.7208 29.6755 22.3108 30.9835 20.5584C32.0563 19.1217 33.4798 18.6964 35.9338 18.6306L36.7011 18.6204C38.3102 18.6204 40.4075 15.9019 42.3207 11.6825C39.8036 10.8201 37.1607 10.3816 34.5 10.3846H34.5015Z"
      fill="url(#paint0_linear_14690_9415)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9415"
        x1="34.5"
        y1="6"
        x2="34.5"
        y2="63"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#53C7FF" />
        <stop offset="1" stopColor="#136AFF" />
      </linearGradient>
    </defs>
  </svg>
);

const svg2 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35 4C29.2222 9.8125 20.5556 12.9125 9 12.9125V34.225C9 43.1375 13.3333 51.6625 20.5556 56.3125L35 66L49.4444 56.3125C56.6667 51.6625 61 43.1375 61 34.225V12.9125C49.4444 12.9125 40.7778 9.8125 35 4ZM57.0278 33.8375C57.0278 41.2 53.0556 47.7875 47.2778 51.6625L35 60.575L22.7222 51.6625C16.9444 48.175 13.3333 41.2 12.9722 33.8375V17.5625C20.5556 17.5625 28.1389 14.85 35 10.5875C41.5 14.85 49.0833 17.5625 57.0278 17.5625V33.8375Z"
      fill="url(#paint0_linear_14690_9394)"
    />
    <path
      d="M24.9633 44.9947C22.7787 44.9947 21 43.3207 21 41.2627C21 40.2472 21.4124 39.2947 22.1584 38.5837C22.8599 37.9093 23.8143 37.5135 24.822 37.4791C25.8297 37.4447 26.8127 37.7744 27.5653 38.3992C28.1292 38.8687 28.5481 39.5002 28.7527 40.1932H37.7137C37.7974 40.1932 38.5547 40.1827 39.2732 39.8497C40.1062 39.4642 40.5106 38.8162 40.5106 37.8682C40.5106 36.8767 40.0449 36.1132 39.125 35.5957C38.4306 35.2057 37.675 35.0782 37.5848 35.0722H33.4168C32.9271 35.0137 31.4046 34.7602 30.0641 33.7522C29.4827 33.3199 29.0065 32.7774 28.6673 32.1607C28.2795 31.4358 28.0834 30.635 28.0953 29.8252C28.0953 28.1917 28.7962 26.8717 30.1221 26.0107C31.4996 25.1197 33.0141 25.0507 33.4458 25.0507H34.5333C35.2551 25.1587 35.7465 25.6837 35.7465 26.2762C35.7465 26.9272 35.1633 27.5002 34.4979 27.5002H33.4458C33.3621 27.5002 32.6048 27.5107 31.8847 27.8437C31.0646 28.2232 30.6473 28.8907 30.6473 29.8252C30.6473 30.8167 31.1146 31.5817 32.0361 32.0992C32.7289 32.4892 33.4845 32.6152 33.5747 32.6212H37.7346C38.9597 32.7449 40.123 33.1862 41.0922 33.8947C42.3827 34.8577 43.0658 36.2152 43.0658 37.8157C43.0658 41.5927 39.5648 42.5902 37.7137 42.5902H28.6512C28.3934 43.2277 27.9407 43.8022 27.3639 44.2192C26.6781 44.7183 25.8337 44.9911 24.9633 44.9947ZM24.9633 39.8752C24.1981 39.8752 23.552 40.5112 23.552 41.2627C23.552 41.9842 24.1981 42.5947 24.9633 42.5947C25.7109 42.5947 26.3312 41.9767 26.3747 41.1892C26.3672 40.8429 26.2162 40.5127 25.9531 40.2677C25.69 40.0228 25.3353 39.8821 24.9633 39.8752ZM46.0286 30.0592C45.503 30.0576 44.9831 29.9568 44.5005 29.7629C44.0179 29.569 43.5824 29.2861 43.2204 28.9312C42.4784 28.2203 42.0639 27.2676 42.0653 26.2762C42.0653 25.2622 42.4761 24.3112 43.2237 23.5957C43.5874 23.2454 44.0233 22.967 44.5052 22.7771C44.9872 22.5871 45.5053 22.4896 46.0286 22.4902C47.0903 22.4902 48.086 22.8832 48.8336 23.5957C49.5811 24.3097 49.9936 25.2607 49.9936 26.2762C49.9936 27.2902 49.5811 28.2412 48.8336 28.9537C48.4696 29.3038 48.0337 29.5821 47.5518 29.7721C47.0699 29.962 46.5519 30.0597 46.0286 30.0592ZM46.0286 24.9412C45.651 24.944 45.29 25.0861 45.0248 25.3364C44.7596 25.5867 44.6119 25.9247 44.6141 26.2762C44.6141 26.9962 45.2617 27.6082 46.0286 27.6082C46.4039 27.6008 46.7614 27.4576 47.0251 27.2089C47.2889 26.9603 47.4383 26.6257 47.4416 26.2762C47.4395 25.9261 47.2907 25.5906 47.0267 25.3412C46.7628 25.0918 46.4046 24.9483 46.0286 24.9412ZM37.4382 27.4462C36.6809 27.4462 36.1316 26.9317 36.1316 26.2222C36.1316 25.4887 36.8066 24.9982 37.4382 24.9982H40.2624C41.0422 24.9982 41.5674 25.6297 41.5674 26.2222C41.5641 26.5444 41.4259 26.8525 41.1821 27.0812C40.9384 27.3098 40.6084 27.4408 40.2624 27.4462H37.4382Z"
      fill="url(#paint1_linear_14690_9394)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9394"
        x1="35"
        y1="4"
        x2="35"
        y2="66"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C9FF" />
        <stop offset="1" stopColor="#095CFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14690_9394"
        x1="35.4968"
        y1="22.4902"
        x2="35.4968"
        y2="44.9947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C9FF" />
        <stop offset="1" stopColor="#095CFF" />
      </linearGradient>
    </defs>
  </svg>
);

const svg3 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4209 40.6064C15.1474 40.6064 16.5527 42.0118 16.5527 43.7383V60.3564C16.5589 62.0829 15.1537 63.4883 13.4209 63.4883H7.66211C5.92935 63.4883 4.52354 62.0829 4.52344 60.3564V43.7383C4.52344 42.0118 5.92885 40.6066 7.65527 40.6064H13.4209ZM55.5439 39.4736C56.8167 39.2027 58.1658 39.372 59.3252 39.958L60.8057 40.6953C62.3305 41.4578 63.4336 42.8447 63.8369 44.502C64.24 46.159 63.887 47.8979 62.8789 49.2715L56.8047 57.5576C55.6831 59.2085 53.9623 60.5255 51.7002 61.4707C49.9738 62.1889 47.9197 62.6935 45.5947 62.9707C43.9691 63.1786 42.4376 63.2354 41.1963 63.2354C39.7094 63.2353 38.6442 63.1531 38.3418 63.1279H21.0137C19.1928 63.1278 17.712 61.6471 17.7119 59.8262V44.3633C17.7119 42.5423 19.1928 41.0617 21.0137 41.0615H40.3086C41.638 41.0616 42.9232 41.4583 44.0195 42.208C45.1158 42.9577 45.9537 44.0162 46.4326 45.251L47.3086 47.501L52.2871 41.4521C53.1125 40.4441 54.2713 39.7447 55.5439 39.4736ZM7.6748 60.3369H13.4082V43.751H7.6748V60.3369ZM57.9199 42.7812C56.8172 42.2331 55.5001 42.5105 54.7188 43.4619L46.4961 53.4561H30.0186C29.149 53.4561 28.4434 52.7494 28.4434 51.8799C28.4436 51.0105 29.1491 50.3047 30.0186 50.3047H45.0029L45.0088 50.292L43.4961 46.3916C42.9793 45.0623 41.7257 44.2051 40.3018 44.2051H21.0137V44.2119C20.9319 44.2121 20.8623 44.2815 20.8623 44.3633V59.8262C20.8624 59.9079 20.9319 59.9774 21.0137 59.9775H38.4932L38.5693 59.9834C38.6163 59.9849 41.7408 60.2783 45.2793 59.8447C48.3606 59.4667 52.4127 58.4583 54.2148 55.7803L54.2529 55.7305L60.3457 47.4189C60.8057 46.7951 60.963 46.0008 60.7803 45.251C60.5974 44.5014 60.0934 43.865 59.4004 43.5186L57.9199 42.7812ZM50.3252 24.126C51.7156 24.126 53.0674 24.5885 54.167 25.4395C55.2664 26.2904 56.0526 27.4823 56.4014 28.8281H60.5195C60.6224 28.8281 60.7243 28.8483 60.8193 28.8877C60.9145 28.9271 61.0014 28.9848 61.0742 29.0576C61.147 29.1304 61.2048 29.2174 61.2441 29.3125C61.2834 29.4075 61.3037 29.5095 61.3037 29.6123V31.1807C61.3037 31.2835 61.2835 31.3854 61.2441 31.4805C61.2047 31.5756 61.147 31.6625 61.0742 31.7354C61.0014 31.8081 60.9144 31.8659 60.8193 31.9053C60.7243 31.9446 60.6224 31.9648 60.5195 31.9648H56.4014C56.0525 33.3106 55.2665 34.5026 54.167 35.3535C53.0674 36.2045 51.7156 36.666 50.3252 36.666C48.9349 36.6659 47.5839 36.2044 46.4844 35.3535C45.3848 34.5026 44.5989 33.3107 44.25 31.9648H30.7217C30.6188 31.9648 30.5169 31.9446 30.4219 31.9053C30.3268 31.8659 30.2398 31.8081 30.167 31.7354C30.0942 31.6625 30.0365 31.5756 29.9971 31.4805C29.9577 31.3855 29.9375 31.2835 29.9375 31.1807V29.6123C29.9375 29.5095 29.9578 29.4075 29.9971 29.3125C30.0364 29.2175 30.0943 29.1304 30.167 29.0576C30.2398 28.9848 30.3267 28.9271 30.4219 28.8877C30.5169 28.8483 30.6188 28.8282 30.7217 28.8281H44.25C44.5988 27.4822 45.3849 26.2904 46.4844 25.4395C47.5839 24.5886 48.9349 24.126 50.3252 24.126ZM50.3252 27.2598C49.4934 27.2599 48.6956 27.5906 48.1074 28.1787C47.5194 28.7669 47.1885 29.5647 47.1885 30.3965C47.1885 31.2283 47.5193 32.0261 48.1074 32.6143C48.6956 33.2024 49.4934 33.5331 50.3252 33.5332C51.1569 33.5332 51.9548 33.2023 52.543 32.6143C53.1311 32.0261 53.4619 31.2283 53.4619 30.3965C53.4619 29.5646 53.1312 28.7669 52.543 28.1787C51.9547 27.5905 51.157 27.2598 50.3252 27.2598ZM40.916 8.44336C42.3063 8.44341 43.6573 8.90503 44.7568 9.75586C45.8565 10.6068 46.6424 11.7995 46.9912 13.1455H60.5195C60.6225 13.1455 60.7242 13.1657 60.8193 13.2051C60.9145 13.2445 61.0014 13.3022 61.0742 13.375C61.1469 13.4477 61.2048 13.5339 61.2441 13.6289C61.2835 13.7239 61.3036 13.8259 61.3037 13.9287V15.4971C61.3037 15.6 61.2835 15.7027 61.2441 15.7979C61.2048 15.8928 61.1469 15.979 61.0742 16.0518C61.0014 16.1246 60.9145 16.1823 60.8193 16.2217C60.7242 16.2611 60.6225 16.2812 60.5195 16.2812H46.9912C46.6424 17.6272 45.8565 18.8199 44.7568 19.6709C43.6573 20.5217 42.3063 20.9833 40.916 20.9834C39.5256 20.9834 38.1739 20.5219 37.0742 19.6709C35.9746 18.8199 35.1887 17.6272 34.8398 16.2812H30.7217C30.6188 16.2812 30.517 16.2611 30.4219 16.2217C30.3267 16.1823 30.2398 16.1246 30.167 16.0518C30.0944 15.979 30.0364 15.8928 29.9971 15.7979C29.9577 15.7027 29.9375 15.6 29.9375 15.4971V13.9287C29.9376 13.8259 29.9577 13.7239 29.9971 13.6289C30.0364 13.5339 30.0944 13.4477 30.167 13.375C30.2398 13.3022 30.3268 13.2445 30.4219 13.2051C30.517 13.1657 30.6188 13.1455 30.7217 13.1455H34.8398C35.1887 11.7996 35.9747 10.6068 37.0742 9.75586C38.1739 8.90489 39.5256 8.44336 40.916 8.44336ZM40.916 11.5771C40.0843 11.5771 39.2864 11.9071 38.6982 12.4951C38.1101 13.0832 37.7794 13.8812 37.7793 14.7129C37.7793 15.5448 38.11 16.3434 38.6982 16.9316C39.2864 17.5196 40.0843 17.8496 40.916 17.8496C41.7477 17.8495 42.5456 17.5197 43.1338 16.9316C43.722 16.3434 44.0527 15.5448 44.0527 14.7129C44.0526 13.8812 43.7219 13.0832 43.1338 12.4951C42.5456 11.907 41.7478 11.5772 40.916 11.5771Z"
      fill="url(#paint0_linear_14690_9398)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9398"
        x1="34.2618"
        y1="36.4351"
        x2="34.2618"
        y2="63.4883"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C9FF" />
        <stop offset="1" stopColor="#0C60FF" />
      </linearGradient>
    </defs>
  </svg>
);

const svg4 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.0539 67.9316L24.0807 51.3724C19.6731 49.2967 15.9465 46.0105 13.3358 41.8971C10.7251 37.7837 9.33786 33.0128 9.33594 28.1408C9.33454 13.9882 20.8481 2.47461 35.0007 2.47461C49.1519 2.47461 60.6655 13.9882 60.6655 28.1408C60.6655 38.4686 54.6063 47.6456 45.1689 51.7126L35.0539 67.9316ZM35.0007 6.67461C23.1637 6.67461 13.5345 16.3038 13.5345 28.1408C13.5362 32.3054 14.7479 36.3798 17.0223 39.8684C19.2968 43.357 22.536 46.1095 26.3459 47.7912L26.9087 48.039L34.9475 60.1672L42.3255 48.3372L42.9639 48.0824C46.9578 46.5001 50.3823 43.7512 52.7909 40.1941C55.1996 36.637 56.4806 32.4367 56.4669 28.1408C56.4655 16.3038 46.8363 6.67461 35.0007 6.67461Z"
      fill="url(#paint0_linear_14690_9403)"
    />
    <path
      d="M26.0156 20.1484H29.02V38.4436H26.0156V20.1484Z"
      fill="url(#paint1_linear_14690_9403)"
    />
    <path
      d="M29.7208 39.1444H25.3164V19.4492H29.7208V39.1444ZM26.7164 37.7444H28.3208V20.8492H26.7164V37.7444Z"
      fill="url(#paint2_linear_14690_9403)"
    />
    <path
      d="M41.3033 31.3739H36.3529V38.4439H33.2617V20.0605H41.4811C45.4879 20.2369 47.6369 22.0933 47.9323 25.6283C47.8721 29.3999 45.6615 31.3151 41.3033 31.3739ZM41.0373 22.8003H36.3515V28.7209H41.0373C43.5699 28.7209 44.8383 27.6905 44.8383 25.6283C44.7193 23.8027 43.4523 22.8591 41.0373 22.8003Z"
      fill="url(#paint3_linear_14690_9403)"
    />
    <path
      d="M37.0537 39.1447H32.5625V19.3613H41.4819C46.9881 19.6035 48.4049 22.8711 48.6303 25.5717C48.5883 28.5313 47.2821 31.9949 41.3139 32.0747H37.0537V39.1447ZM33.9611 37.7447H35.6523V30.6747H41.3027C45.2913 30.6215 47.1771 29.0143 47.2303 25.6193C46.9657 22.4889 45.1275 20.9237 41.4469 20.7613H33.9597V37.7447H33.9611ZM41.0381 29.4231H35.6523V22.1025H41.0381C44.5773 22.1893 45.4369 24.0443 45.5377 25.5843C45.5391 27.0459 44.9539 29.4231 41.0381 29.4231ZM37.0537 28.0231H41.0395C43.7877 28.0231 44.1405 26.7435 44.1405 25.6305C44.0831 24.7737 43.6967 23.5669 41.0227 23.5025H37.0537V28.0231Z"
      fill="url(#paint4_linear_14690_9403)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9403"
        x1="35.0007"
        y1="2.47461"
        x2="35.0007"
        y2="67.9316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C8FF" />
        <stop offset="1" stopColor="#0B5FFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14690_9403"
        x1="27.5178"
        y1="20.1484"
        x2="27.5178"
        y2="38.4436"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C8FF" />
        <stop offset="1" stopColor="#0B5FFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_14690_9403"
        x1="27.5186"
        y1="19.4492"
        x2="27.5186"
        y2="39.1444"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C8FF" />
        <stop offset="1" stopColor="#0B5FFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_14690_9403"
        x1="40.597"
        y1="20.0605"
        x2="40.597"
        y2="38.4439"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C8FF" />
        <stop offset="1" stopColor="#0B5FFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_14690_9403"
        x1="40.5964"
        y1="19.3613"
        x2="40.5964"
        y2="39.1447"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C8FF" />
        <stop offset="1" stopColor="#0B5FFF" />
      </linearGradient>
    </defs>
  </svg>
);

const svg5 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.0625 29.75H45.9375V33.0312H24.0625V29.75Z"
      fill="url(#paint0_linear_14690_9409)"
    />
    <path
      d="M61.25 29.75H54.6875V33.0313H59.0625L61.0312 38.0625H52.5V9.84375H48.125V38.0625H21.875V9.84375H17.5V38.0625H8.96875L10.9375 33.0313H15.3125V29.75H8.96875L4.375 38.0625V60.375H65.625V38.0625L61.25 29.75ZM61.25 55.7812H8.75V42.6562H61.25V55.7812Z"
      fill="url(#paint1_linear_14690_9409)"
    />
    <path
      d="M52.5 47.0312H56.875V51.4062H52.5V47.0312ZM43.75 47.0312H48.125V51.4062H43.75V47.0312ZM35 47.0312H39.375V51.4062H35V47.0312Z"
      fill="url(#paint2_linear_14690_9409)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9409"
        x1="35"
        y1="29.75"
        x2="35"
        y2="33.0312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#50C3FF" />
        <stop offset="1" stopColor="#0C60FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14690_9409"
        x1="35"
        y1="9.84375"
        x2="35"
        y2="60.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#50C3FF" />
        <stop offset="1" stopColor="#0C60FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_14690_9409"
        x1="45.9375"
        y1="47.0312"
        x2="45.9375"
        y2="51.4062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#50C3FF" />
        <stop offset="1" stopColor="#0C60FF" />
      </linearGradient>
    </defs>
  </svg>
);

const svg6 = (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.5387 56.2917C49.1762 58.6833 45.4721 59.9375 40.4554 60.0542C40.3303 59.633 40.0725 59.2634 39.7204 59.0007C39.3682 58.7379 38.9406 58.5959 38.5013 58.5958H31.5887C30.4512 58.5958 29.5471 59.5 29.5471 60.6375V63.5833C29.5471 64.7208 30.4512 65.625 31.5887 65.625H38.4721C39.4346 65.625 40.2221 64.9833 40.4554 64.0792C46.6679 63.9917 51.3637 62.2708 54.5137 59.0625C56.5305 56.9432 57.818 54.2353 58.1888 51.3333C61.6888 50.1958 64.2554 46.8708 64.2554 42.9625V35.5542C64.2554 32.1125 62.2721 29.1083 59.3554 27.65C58.7721 14.7292 48.0679 4.375 35.0012 4.375C21.9375 4.375 11.2013 14.7583 10.6471 27.6792C7.73333 29.1375 5.75 32.1417 5.75 35.5542V42.9917C5.75 47.8333 9.71667 51.8 14.5875 51.8H16.6583C17.7375 51.8 18.6708 50.8958 18.6125 49.7875V28.7583C18.6126 28.2219 18.4015 27.7069 18.0249 27.3249C17.6483 26.9428 17.1364 26.7243 16.6 26.7167H14.7333C15.7542 16.45 24.4458 8.4 34.975 8.4C45.5333 8.4 54.225 16.45 55.2458 26.7167H53.3792C52.2708 26.7167 51.3375 27.6208 51.3375 28.7583V49.7875C51.3375 50.8667 52.2417 51.8 53.3792 51.8H54.0208C53.7292 53.025 53.0583 54.7458 51.5417 56.2917H51.5387Z"
      fill="url(#paint0_linear_14690_9413)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14690_9413"
        x1="35.0027"
        y1="4.375"
        x2="35.0027"
        y2="65.625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#54C9FF" />
        <stop offset="1" stopColor="#1065FF" />
      </linearGradient>
    </defs>
  </svg>
);
